module.exports = __webpack_public_path__ + "img/actionGet.f969ac9e.png";